import Reveal from '@/components/apple/Reveal';
import { WHATSAPP_NUMBER, waLink } from '@/config/site';
import { FOTO_EDNILSON, foto, img } from '@/lib/projetos';
import { ArrowLink, Container, PillButton, SectionTitle } from '@/components/apple/ui';

const ETAPAS = [
  { n: '01', t: 'Conte sua necessidade', d: 'Empresa, cidade, ambientes e o que pretende implantar.' },
  { n: '02', t: 'Análise e layout', d: 'Avaliamos fotos, medidas ou planta — ou o projeto do seu arquiteto.' },
  { n: '03', t: 'Proposta', d: 'Opções claras, normalmente em até 3 dias úteis.' },
  { n: '04', t: 'Entrega e montagem', d: 'Você recebe o ambiente pronto para trabalhar.' },
];

export function Turnkey() {
  const foto1 = foto(6, 2); // Epic Tower — recepção
  return (
    <section className="bg-white py-24 md:py-36">
      <Container>
        <Reveal>
          <SectionTitle
            eyebrow="Turnkey"
            title={
              <>
                Do espaço vazio
                <br className="hidden md:block" /> à empresa pronta.
              </>
            }
            sub="Layout, especificação, fornecimento, entrega e montagem. Cadeiras, mesas, divisórias, carpetes e marcenaria em um único responsável."
          />
        </Reveal>

        <Reveal className="mt-12 md:mt-16">
          <figure>
            <div className="overflow-hidden rounded-[18px] md:rounded-[28px] bg-[#F5F5F7]">
              <img
                src={img(foto1, 1800)}
                alt="Recepção corporativa do Epic Tower em Caruaru, com marcenaria e mobiliário entregues pela HomeOffice Premium"
                loading="lazy"
                decoding="async"
                className="w-full aspect-[4/3] md:aspect-[21/9] object-cover"
              />
            </div>
            <figcaption className="mt-3 text-center text-[12px] md:text-[13px] text-[#6E6E73]">Recepção · Epic Tower, Caruaru</figcaption>
          </figure>
        </Reveal>

        <ol className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
          {ETAPAS.map((e, i) => (
            <Reveal as="li" key={e.n} delay={(i + 1) as 1 | 2 | 3 | 4} className="border-t border-black/[0.1] pt-5">
              <p className="text-[13px] font-semibold text-[#C4500A] tabular-nums">{e.n}</p>
              <h3 className="mt-2 text-[19px] md:text-[21px] font-semibold tracking-[-0.02em] text-[#1D1D1F]">{e.t}</h3>
              <p className="mt-2 text-[15px] leading-[1.5] text-[#6E6E73]">{e.d}</p>
            </Reveal>
          ))}
        </ol>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <div className="rounded-[18px] bg-[#F5F5F7] p-7 md:p-9">
            <h3 className="text-[19px] md:text-[21px] font-semibold tracking-[-0.02em] text-[#1D1D1F]">Já tem arquiteto?</h3>
            <p className="mt-2 text-[15px] md:text-[17px] leading-[1.5] text-[#6E6E73]">
              Trabalhamos em parceria, respeitando o conceito, as medidas e os acabamentos do projeto.
            </p>
          </div>
          <div className="rounded-[18px] bg-[#F5F5F7] p-7 md:p-9">
            <h3 className="text-[19px] md:text-[21px] font-semibold tracking-[-0.02em] text-[#1D1D1F]">Ainda não tem projeto?</h3>
            <p className="mt-2 text-[15px] md:text-[17px] leading-[1.5] text-[#6E6E73]">
              Desenvolvemos o layout do mobiliário e orientamos cada escolha para o espaço funcionar melhor.
            </p>
          </div>
        </div>

        <div className="mt-10 text-center">
          <ArrowLink to="/turnkey">Como funciona o turnkey</ArrowLink>
        </div>
      </Container>
    </section>
  );
}

export function Dono() {
  return (
    <section className="bg-[#F5F5F7] py-24 md:py-36">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
          <Reveal>
            <div className="overflow-hidden rounded-[18px] md:rounded-[28px] bg-white">
              <img
                src={img(FOTO_EDNILSON, 1200)}
                alt="Ednilson, proprietário da HomeOffice Premium, atendendo cliente no showroom em Caruaru"
                loading="lazy"
                decoding="async"
                className="w-full aspect-[4/5] object-cover"
              />
            </div>
          </Reveal>
          <Reveal delay={1}>
            <SectionTitle
              align="left"
              eyebrow="Atendimento direto"
              title="Aqui, quem atende você é o dono."
              sub="Sem intermediários e sem call center. O Neto acompanha cada etapa: o entendimento da necessidade, a análise do ambiente, a escolha dos produtos, a proposta e a entrega."
            />
            <p className="mt-5 text-[17px] md:text-[19px] leading-[1.45] tracking-[-0.015em] text-[#1D1D1F]">
              O objetivo não é vender o item mais caro. É indicar a solução certa para o uso, o espaço e o investimento.
            </p>
            <div className="mt-8">
              <PillButton href={waLink('projetos')}>Falar com o Neto</PillButton>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}

export function Showroom() {
  return (
    <section className="bg-black py-24 md:py-36 text-center">
      <Container>
        <Reveal>
          <SectionTitle
            dark
            eyebrow="Showroom em Caruaru"
            title="Sente antes de decidir."
            sub="Experimente cadeiras, compare acabamentos e consulte catálogos com calma, direto com o proprietário."
          />
        </Reveal>
        <Reveal delay={1}>
          <p className="mt-10 text-[17px] md:text-[21px] text-white tracking-[-0.015em]">Av. Agamenon Magalhães, 1519</p>
          <p className="text-[15px] md:text-[17px] text-white/60">Maurício de Nassau · Caruaru, PE · Atendimento com hora marcada</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-7">
            <PillButton
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
                'Olá Ednilson! Gostaria de agendar uma visita ao showroom da HomeOffice Premium em Caruaru.'
              )}`}
            >
              Agendar visita
            </PillButton>
            <ArrowLink dark href="https://www.google.com/maps/search/?api=1&query=Av.+Agamenon+Magalh%C3%A3es%2C+1519%2C+Caruaru+PE">
              Ver no mapa
            </ArrowLink>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
